import { InfoOutlined } from "@mui/icons-material";
import { Card, Stack, Typography } from "@mui/material";
import useScrollMemory from "hooks/useScrollMemory";
import withHeightFitContent from "hocs/withHeightFitContent";
import useIsCreate from "hooks/useIsCreate";
import Content from "./Content";

const ContentWithHeightFitContent = withHeightFitContent(Content);

interface LeftColumnProps {
  isEditing: boolean;
  skillId: string | undefined;
  isMultiChoiceQuestion: boolean;
}

const LeftColumn = ({ isEditing, skillId, isMultiChoiceQuestion }: LeftColumnProps) => {
  const isCreate = useIsCreate();
  const { ref } = useScrollMemory();

  return (
    <Stack spacing={2.5}>
      {!isCreate && (
        <Card sx={{ padding: 1.5 }}>
          <Stack
            spacing={1}
            direction='row'>
            <InfoOutlined color='info' />
            <Typography>
              При&#160;изменении подтвержденного вопроса&#160;— вопрос будет перенаправлен в&#160;список
              неподтвержденных вопросов. Для&#160;использования вопроса в&#160;рамках тестирований необходимо
              подтвердить данный вопрос.
            </Typography>
          </Stack>
        </Card>
      )}
      <ContentWithHeightFitContent
        skillId={skillId}
        isEditing={isEditing}
        isMultiChoiceQuestion={isMultiChoiceQuestion}
        refProp={ref}
      />
    </Stack>
  );
};

export default LeftColumn;
